<template>
  <v-main class="fundo" >
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
      shaped
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-card :loading="loading" class="box-login" elevation="10">
        <v-row>
          <v-col cols="12" sm="7">
            <v-img src="../../assets/img/bimer.jpg" class="bimer-image"></v-img>
          </v-col>
          <v-col cols="12" sm="5">
            <div class="logo">
              Login
            </div>

            <form class="mt-8 pa-0" autocomplete="off" >
              <v-col cols="12" class="ma-0 pa-0">
                <v-text-field
                  outlined
                  dense
                  color="primary"
                  label="E-mail"
                  v-model="usuario.email"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="ma-0 pa-0">
                <v-text-field
                  @keyup.enter="logar"
                  outlined
                  dense
                  label="Senha"
                  v-model="usuario.senha"
                  :append-icon="value ? 'visibility_off' : 'visibility'"
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="ma-0 pa-0">
                <v-btn
                  color="primary"
                  @click="logar"
                  type="button"
                  class="btn-entrar"
                >
                  Entrar
                </v-btn>
              </v-col>
              <v-col cols="12" class="mt-5">
                <center>
                  <p> {{ copyright }}</p>
                </center>
              </v-col>
            </form>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-main >
</template>
<script>
import mixinMensagen from "@/mixin/mixin-mensagem";
import Usuario from "@/model/usuario/Usuario";
import apiUsuario from "@/api/usuario/usuario-api";
import apiGeral from "@/api/geral-api";
import utilsStorage from "@/utils/storage.js";

const NAVEGADORES = {
  Edge: 'Microsoft Edge',
  Chrome: 'Google Chrome',
  Firefox: 'Firefox',
}
export default {
  name: "login",
  mixins: [mixinMensagen],
  data() {
    return {
      copyright: `©1989 - ${new Date().getFullYear()} - Alterdata Software`,
      loading: false,
      usuario: new Usuario(),
      value: "password",
      ip: undefined
    };
  },

  beforeMount(){
    this.obterIpDaMaquina();
  },

  methods: {

    obterIpDaMaquina(){

      apiGeral.obterIp()
      .then(response => this.ip = response.data.ip )
      .catch(erro => console.log(erro))
    },

    obterObservacaoDoUsuario(){
    
      if(!this.ip || this.ip == "undefined"){
        return "";
      }

      let navegador;

      if(!navigator.userAgentData)
        navegador = NAVEGADORES.Firefox;
      else if(navigator.userAgentData.brands[2].brand == NAVEGADORES.Edge)
        navegador = NAVEGADORES.Edge
      else if(navigator.userAgentData.brands[2].brand == NAVEGADORES.Chrome)
        navegador = NAVEGADORES.Chrome;
      else
        navegador = navigator.userAgent || 'NAO IDENTIFICADO'

      // eslint-disable-next-line no-debugger
      return `Ip: ${this.ip} - Plataforma: ${navigator.platform} - Navegador: ${navegador} - Linguagem: ${navigator.language}`;
    },
    logar() {
      if (!this.usuario.email || !this.usuario.senha) {
        this.dispararMensagem("Informe o login e senha de rede para acesso.", "error");
        return;
      }
      this.loading = true;

      apiUsuario
        .logar(this.usuario, this.obterObservacaoDoUsuario())
        .then((response) => {
          this.loading = false;
        
          let usuario = new Usuario({
            email: response.data.clienteEmail,
            clienteId: response.data.clienteId,
            token: response.data.token,
            workspaces: response.data.workspaces
          });

          this.salvarInformacoesLocalStorage(usuario);

         this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
                    this.loading = false;
          this.dispararMensagem(
            error.response &&
              error.response.data &&
              error.response.data.message || "Não foi possível efetuar a autenticação.",
            "error"
          );

          this.loading = false;
        });
    },

    salvarInformacoesLocalStorage(usuario) {
      utilsStorage.salvarUsuarioNaStorage(usuario);
    },
  },
};
</script>
<style lang="scss" scoped>
.box-login {
  background-color: $white;
  width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 120px;
  
  padding: 30px;
  padding-bottom: 0px;
  border-radius: 5px;
}

.logo {
  font-size: 45px;
  font-weight: 600;
  text-align: center;
  display: block;
  margin: auto auto;
  color: $cor-primaria;

}

.btn-entrar {
  width: 100%;
  font-weight: 600;
  border: 1px solid #ddd;
  margin: 0;
}

.btn-entrar:hover {
  cursor: pointer;
  background-color: rgb(217, 223, 217);
}

.btn-entrar:focus {
  outline: none;
}

.bimer-image{
  margin-top: 60px;
}

.fundo {
  background: linear-gradient(
      rgba(48, 63, 122, 0.651),
      rgba(144,144,144, 0.651)
    ),
  url("../../assets/img/fundo01.jpg");
  background-size: cover;                  
  background-repeat: no-repeat;
  background-position: center center;   
}

div {
  width: 100%;
}
</style>
